<template>
    <div v-if="!isWeixin" class="sq-notice">
        <div class="weui-msg">
            <div class="weui-msg__icon-area">
                <i class="el-icon-warning" style="color: #2b94ff;font-size:100px">
                </i>
            </div>
            <div class="weui-msg__text-area">
                <h2 class="weui-msg__title">温馨提示</h2>
                <p class="weui_msg__desc">{{notice}}</p>
            </div>
        </div>
    </div>
    <div class="qkk-page" v-else>
        <van-nav-bar :title="title" left-text="" @click-left="onClickLeft" left-arrow :fixed="true">
        </van-nav-bar>
        <div style="margin-top: -5px;padding: 10px 26px">
            <div style="display: flex;flex-direction: row">
                <img :src="member.headPortrait" style="width: 45px;height: 45px;" v-if="member.headPortrait">
                <img src="./../../assets/touxiang.png" style="width: 45px;height: 45px;" v-if="!member.headPortrait">
                <div class="qkk-mbinfo">
                    <span style="height: 23px">{{member.memberName}}</span>
                    <span>{{member.phone}}</span>
                </div>
            </div>
            <div style="font-size: 12px;margin-top: 8px">
                <span style="display: block;">{{member.memberName}} 送您福利卡!</span>
                <span style="display: block;margin-top: 5px">本卡无任何隐形消费及附加条件."<span style="color: #ff4d51">点击领取</span>"到店即可使用</span>
            </div>
            <div class="qkk-mmr">
                <img :src="reward.imgUrl" style="width: 65px;height: 65px;border-radius: 5px">
                <div class="qkk-name">
                    <span style="height: 30px;">{{reward.icName}}</span>
                    <span style="height: 32px;line-height: 46px;color: #ff4d51">¥ {{reward.price}}</span>
                </div>
                <span class="qkk-lqbtn" v-if="status==0" @click="lq"> 免费领取 </span>
                <span class="qkk-lqbtn1" v-if="status==1" disabled> 领取上限 </span>
                <span class="qkk-lqbtn1" v-if="status==2" disabled> 已领取 </span>
            </div>
            <div style="width: 95%;margin:auto;">
                <div style="display: flex;flex-direction: column;font-size: 13px;border: #dddddd solid 1px;margin-bottom: 12px"
                     v-for="it in msiList">
                    <div style="height: 25px;line-height: 25px;background-color: #FAF1E9;display: flex;flex-direction: row;font-size: 12px">
                        <span style="width: 47%;padding: 0px 8px">{{it.itemName}}</span>
                        <span style="width: 26%;padding: 0px 8px;text-align: right">{{it.quantity+'份/RMB'}}</span>
                        <span style="width: 26%;padding: 0px 8px;text-align: center">{{it.quantity*it.price}}</span>
                    </div>
                    <div style="padding: 15px">
                        <div>
                            <span style="height: 25px">服务时长:</span>
                            <span style="
                         height: 20px;line-height: 20px">
                            {{it.serviceTime}}
                        </span>
                        </div>
                        <div>
                            <span style="height: 25px">流程:</span>
                            <span style=" height: 20px;line-height: 20px">
                           {{it.step}}
                        </span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div>
            <van-cell-group custom-class="goods-cell-group">
                <van-cell icon="shop-o" is-link @click="toMds">
                    <span style="font-size: 12px">查看可用门店</span>
                </van-cell>
            </van-cell-group>
        </div>
        <div>
            <p v-html="reward.description"></p>
        </div>
        <van-popup v-model="mdShow" position="bottom">
            <div style="height: 380px;background-color: #EEEEEE">
                <div class="ms-mds">
                    <span>适用门店</span>
                    <span>
                        <i class="el-icon-circle-close" style="font-size: 23px" @click="gbmds"></i>
                    </span>
                </div>
                <div class="md-items" v-for="item in mds">
                    <div class="md-item">
                        <span><i class="el-icon-s-shop"></i></span>
                        <span style="margin-left: 8px">{{item.deptName}}</span>
                    </div>
                    <div class="md-item">
                        <span><i class="el-icon-location-information"></i></span>
                        <span style="margin-left: 8px">{{item.address}}</span>
                    </div>
                    <div class="md-item">
                        <span><i class="el-icon-phone-outline"></i></span>
                        <span style="margin-left: 8px">{{item.phone}}</span>
                    </div>
                </div>
            </div>
        </van-popup>
    </div>
</template>

<script>
    import {getCookie, getDeptId, getDeptName, setYqUrl} from "../../utils/auth";

    export default {
        data() {
            return {
                notice: '请在微信客户端打开链接!',
                isWeixin: true,
                title: '请客尊享福利',
                deptId: '',
                token: '',
                mid: '',
                mmrId: '',

                member: {},
                reward: {},
                status: 0,
                msiList: [],

                mdShow: false,
                mds: [],
            };
        },
        async mounted() {
            document.title = getDeptName()
            this.mid = this.$route.params.mid
            this.mmrid = this.$route.params.mmrid
            this.deptId = getDeptId()
            this.token = getCookie('spmToken')
            await this.panduan()
            if (this.isWeixin) {
                if (!this.token) {
                    setYqUrl('/qkk/' + this.deptId + '/' + this.mid + '/' + this.mmrid)
                    this.$router.push('/invite/' + this.deptId + '/' + this.mid)
                }
            }
            this.getSpmMbRewardDetails()
        },
        methods: {
            toMds() {
                this.mdShow = true
            },
            gbmds() {
                this.mdShow = false
            },
            lq() {
                var that = this
                // let total = 0
                var arr = []
                that.msiList.forEach(item => {
                    item.TOTAL = item.quantity
                    item.firstAch = item.empAch
                    item.secondAch = item.empAch
                    item.thirdAch = item.empAch
                    arr.push(item)
                })
                // if (parseInt(total) > that.reward.num) {
                //     that.$toast('所选的商品数量超出' + that.reward.num + ',不能下单！');
                //     return;
                // }
                // if (parseInt(total) < that.reward.num) {
                //     that.$toast('所选的商品数量低于' + that.reward.num + ',不能下单！');
                //     return;
                // }
                // that.$dialog.confirm({
                //     title: '提示',
                //     message: '确认领取'
                // }).then(() => {
                //     that.lqReward(arr)
                // }).catch(() => {
                // });
                that.lqReward(arr)
            },

            async lqReward(arr) {
                let data = {
                    token: this.token,
                    mid: this.mid,
                    mmrid: this.mmrid,
                    goodsStr: JSON.stringify(arr)
                }
                let res = await this.$post("/spm/spmLqReward", data)
                if (res.code == 200) {
                    this.$notify({
                        message: res.message,
                        duration: 1000,
                        background: '#1989fa'
                    });
                    this.getSpmMbRewardDetails()
                } else {
                    this.$notify({
                        message: res.message,
                        duration: 1000,
                        background: 'red'
                    });
                }
            },
            async getSpmMbRewardDetails() {
                let data = {
                    token: this.token,
                    mid: this.mid,
                    mmrid: this.mmrid
                }
                let res = await this.$get("/spm/getSpmMbRewardDetails", data)
                this.member = res.member
                this.reward = res.reward
                this.mds = res.mssList
                this.msiList = res.srgs
                if (this.msiList.length > 0) {
                    this.msiList.forEach(item => {
                        item.total = item.quantity
                        item.miType = item.itemType
                        item.goodsItemId = item.id
                        // item.step = JSON.parse(item.step)
                    })
                }
                this.status = res.status
            },

            panduan() {
                let that = this;
                var ua = navigator.userAgent.toLowerCase(); //判断是否是微信浏览器
                var isWeixin = ua.indexOf("micromessenger") != -1; //判断是否
                this.isWeixin = isWeixin
                if (!isWeixin) {
                    return false;
                }
            },
            setNum() {

            },
            onClickLeft() {
                this.$router.push('/home/' + this.deptId)
            },
        },
    };
</script>

<style lang="scss" scoped>
    .qkk-page {
        margin: 0 auto;
        height: 100%;
        position: relative;
        background-color: #ffffff;
        padding-top: 53px;
    }

    .qkk-mbinfo {
        font-size: 13px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        margin-left: 8px
    }

    .qkk-mmr {
        margin-top: 35px;
        display: flex;
        flex-direction: row;
        align-items: center;
        background-color: #F7F7F7;
        padding: 10px;
        margin-bottom: 16px;
    }

    .qkk-name {
        display: flex;
        flex-direction: column;
        font-size: 15px;
        margin-left: 12px;
        width: 43%;
    }

    .qkk-lqbtn {
        font-size: 13px;
        background-color: #ff4d51;
        color: #ffffff;
        padding: 2px 5px;
    }

    .qkk-lqbtn1 {
        font-size: 13px;
        background-color: #B3B3B3;
        color: #ffffff;
        padding: 2px 5px;
    }

    .spec-btn1 {
        font-size: 15px;
        width: 100%;
        color: #FFFFFF;
        height: 38px;
        line-height: 38px;
    }

    .d-btn {
        width: 100%;
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        position: fixed;
        bottom: 0px;
        background-color: #FFFFFF;
        height: 38px;
    }


    .sq-notice {
        margin: auto;
        font-size: 18px;
        text-align: center;
        margin-top: 23%;
    }

    .weui-msg {
        padding-top: 36px;
        text-align: center;
    }

    .weui-msg__icon-area {
        margin-bottom: 30px;
    }

    .weui-icon_msg {
        font-size: 93px;
    }

    .weui-icon-info {
        font-size: 23px;
        color: #10aeff;
    }

    .weui-msg__text-area {
        margin-bottom: 25px;
        padding: 0 20px;
    }

    .weui-msg__title {
        margin-bottom: 5px;
        font-weight: 400;
        font-size: 20px;
    }

    .weui_msg__desc {
        margin-top: 16px;
    }

    .ms-mds {
        font-size: 16px;
        padding: 3px 8px;
        border-bottom: #EEEEEE solid 1px;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        background-color: #ffffff;
    }

    .md-items {
        display: flex;
        flex-direction: column;
        padding: 8px;
        width: 98%;
        margin: auto;
        background-color: #ffffff;
        border-radius: 5px;
        margin-top: 5px;
    }

    .md-item {
        display: flex;
        flex-direction: row;
        height: 20px;
        line-height: 20px;
    }

    .md-item span {
        font-size: 13px;
    }
</style>
